import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import rootReducers from "./ducks";

import { composeWithDevTools } from "redux-devtools-extension";

const middlewares = [thunk].filter(Boolean);

const allStoreEnhancers = composeWithDevTools(applyMiddleware(...middlewares));
const store = createStore(rootReducers, allStoreEnhancers);

export default store;
